import React from 'react';
import { Alert, Button } from '@odin-labs/components';
import { CopyIcon, PlusIcon } from 'components/icons';
import { AddShiftModal } from 'containers/jobsite/tabs/jobsiteSchedules/modals';
import { ImportScheduleModal } from 'containers/schedules/modals/ImportScheduleModal';
import { useBoolean } from 'utils';
import { GetScheduleDetailsDocument } from 'apollo/generated/client-operations';
import { JobsiteScheduleEmptyState } from './JobsiteScheduleEmptyState';
import { useJobsiteSchedules } from './jobsiteSchedulesProvider';
import { JobsiteScheduleLoading } from './JobsiteScheduleLoading';
import { JobsiteSchedule } from './JobsiteSchedule';

export function JobsiteSchedules(): React.ReactElement {
  const { selectedSchedule, isScheduleEditable, isScheduleLive, loading } =
    useJobsiteSchedules();

  // TODO: Temporary flag. Remove hasNoShifts and its reference when we allow for multiple shifts.
  const hasNoShifts = !selectedSchedule?.shifts.length;

  const {
    value: isAddShiftModalOpen,
    setTrue: openAddShiftModal,
    setFalse: closeAddShiftModal,
  } = useBoolean();

  const {
    value: isImportScheduleModalOpen,
    setTrue: openImportScheduleModal,
    setFalse: closeImportScheduleModal,
  } = useBoolean();

  if (loading) {
    return <JobsiteScheduleLoading />;
  }

  return (
    <>
      {isScheduleLive && isScheduleEditable && (
        <Alert text="You are editing a past-date schedule. Work may have already started." />
      )}
      {selectedSchedule ? (
        <div className="odin-flex odin-flex-col odin-gap-4">
          {selectedSchedule.shifts.length === 0 ? (
            <JobsiteScheduleEmptyState message="No workers scheduled." />
          ) : (
            <JobsiteSchedule />
          )}

          {isScheduleEditable && hasNoShifts && (
            <div className="odin-flex odin-justify-center odin-gap-2">
              <Button
                icon={PlusIcon}
                onClick={openAddShiftModal}
                size="sm"
                text="Add Shift"
                theme="secondary"
              />
              <Button
                icon={CopyIcon}
                onClick={openImportScheduleModal}
                size="sm"
                text="Import Schedule"
                theme="white"
              />
            </div>
          )}
        </div>
      ) : (
        <JobsiteScheduleEmptyState message="No schedule has been configured for this date." />
      )}
      <AddShiftModal
        isOpen={isAddShiftModalOpen}
        closeModal={closeAddShiftModal}
        selectedSchedule={selectedSchedule}
      />
      <ImportScheduleModal
        isOpen={isImportScheduleModalOpen}
        closeModal={closeImportScheduleModal}
        selectedSchedule={selectedSchedule}
        refetchQuery={GetScheduleDetailsDocument}
      />
    </>
  );
}
